import {  createSlice } from '@reduxjs/toolkit';
import {CustomerResponse, CustomerResponseState} from '../models/CustomerModels'


const initialState:CustomerResponseState = {
     customerList :[]
}

const customerListSlice = createSlice({
    name:'user',
    initialState,
    reducers:{
        setCustomerList(state,action:{payload:CustomerResponse[]}){
            state.customerList = action.payload;
        }
    }
});

export const {
    setCustomerList
} = customerListSlice.actions;

export default customerListSlice.reducer;